module.exports = __webpack_public_path__ + "static/media/people-carry.176392a1.svg";